"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MuiSubmit = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _MuiIcon = _interopRequireDefault(require("../MuiIcon/MuiIcon"));

/**
   * Submit Button For Form
   * MuiSubmit Button For Form
*/
var MuiSubmit = function MuiSubmit(_ref) {
  var submitting = _ref.submitting,
      color = _ref.color,
      disableElevation = _ref.disableElevation,
      disableFocusRipple = _ref.disableFocusRipple,
      disableRipple = _ref.disableRipple,
      endIcon = _ref.endIcon,
      fullWidth = _ref.fullWidth,
      size = _ref.size,
      startIcon = _ref.startIcon,
      variant = _ref.variant,
      buttonText = _ref.buttonText;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, submitting && /*#__PURE__*/_react.default.createElement(_CircularProgress.default, null), !submitting && /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "submit",
    color: color,
    disableElevation: disableElevation,
    disableFocusRipple: disableFocusRipple,
    disableRipple: disableRipple,
    endIcon: endIcon ? /*#__PURE__*/_react.default.createElement(_MuiIcon.default, {
      iconName: endIcon
    }) : null,
    fullWidth: fullWidth,
    size: size,
    startIcon: startIcon ? /*#__PURE__*/_react.default.createElement(_MuiIcon.default, {
      iconName: startIcon
    }) : null,
    variant: variant,
    "data-testid": "Button"
  }, buttonText));
};

exports.MuiSubmit = MuiSubmit;
var _default = MuiSubmit;
exports.default = _default;
MuiSubmit.propTypes = {
  /** passed down from React Final Form when submitting */
  submitting: _propTypes.default.bool,

  /** button text */
  buttonText: _propTypes.default.string,

  /**
     * mui prop: 'default'| 'inherit'| 'primary'| 'secondary'
     * The color of the component. It supports those theme colors that make sense for this component.
     * */
  color: _propTypes.default.string,

  /**
     * mui prop: true | false
     * If true, no elevation is used.
     */
  disableElevation: _propTypes.default.bool,

  /**
     * mui prop: true | false
     * If true, the keyboard focus ripple will be disabled. disableRipple must also be true.
     */
  disableFocusRipple: _propTypes.default.bool,

  /**
     * mui prop: true | false
     * If true, the ripple effect will be disabled.
     * Without a ripple there is no styling for :focus-visible by default. Be sure to highlight the element by applying separate styles with the focusVisibleClassName.
     */
  disableRipple: _propTypes.default.bool,

  /**
     * name of Icon uses MuiIcon
     * Element placed after the children. renders icon
     * any icon from https://material.io/resources/icons/?style=baseline
     * */
  endIcon: _propTypes.default.string,

  /**
     * mui prop: true | false
     * If true, the button will take up the full width of its container.
     */
  fullWidth: _propTypes.default.bool,

  /**
     * mui prop: 'small'| 'medium'| 'large'
     * The size of the button. small is equivalent to the dense button styling.
     * */
  size: _propTypes.default.string,

  /**
     * name of Icon uses MuiIcon
     * Element placed before the children. renders icon
     * any icon from https://material.io/resources/icons/?style=baseline
     * */
  startIcon: _propTypes.default.string,

  /**
   * mui prop: 'text' |'outlined'| 'contained
   * The variant to use.
   * */
  variant: _propTypes.default.string
};
MuiSubmit.defaultProps = {
  submitting: false,
  buttonText: 'submit',
  color: 'secondary',
  disableElevation: false,
  disableFocusRipple: false,
  disableRipple: false,
  endIcon: null,
  fullWidth: true,
  size: 'medium',
  startIcon: null,
  variant: 'text'
};